import React from 'react'
import './index.less'
import { CHARGE_CDN } from '../../../../utils/constants'
import SharingUserInfo from '../sharing-user-info'
interface SharingUserItemPropsRule {
    key: any
    data: any
    onRemove: () => void
}
const SharingUserItem = (props: SharingUserItemPropsRule) => {
    const { key, data, onRemove } = props
    return <div className='sharing-user-item' key={key}>
        <div className='top'>
            <SharingUserInfo data={data} />
            <div className='remove' onClick={onRemove}>移除共享</div>
        </div>
        <div className='bottom'>
            <div className='use-time'>{data?.newestOrderTime ? `上次使用时间：${data?.newestOrderTime}` : '该用户未使用过你的共享家充'}</div>
        </div>
    </div>
}

export default SharingUserItem